import { IPlayer, ISiteSetting } from "../../../../../types/api";

const isPlayoffEligible = (
    player: IPlayer,
    currentYear: number,
    playoffEligibileDate?: ISiteSetting["setting"],
) => {
    const waiverDate =
        player.waiverAccepted &&
        player.waiverYear === currentYear &&
        new Date(player.waiverAccepted);

    const playoffDate = new Date(playoffEligibileDate as string);

    return waiverDate && waiverDate < playoffDate ? true : false;
};

export default isPlayoffEligible;
